module.exports = __webpack_public_path__ + "91aea3511e9b0f327d2ea838e8d33935.svg";